var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// @ts-ignore
import * as callToActionUtils from 'conversional-utils/callToActions';
// @ts-ignore
import { getJourneySettings, persistCurrentJourneyOnSettings } from 'conversional-environment/settings';
import { addPreloaderIframe, getRootLauncher, parseQueryString, runLauncher } from './dom/utils';
import { addLauncherStyles } from './styles';
import { getJourneyConfig } from './api';
import { configureUrl } from './url';
import { deepMerge } from './functions';
import { initializeLauncher, removeFromDOM, removeIframesFromDOM } from './dom';
import { checkInlineWidgetAndRenderLoading, renderLoading } from './dom/loading';
import createIframes, { resetIframeCreation } from './createIframes';
import { waitForClient, waitForUserInteraction } from './wait';
import { processCTAClick } from './actions/actions';
import { captureConversionalSettingsChange } from './spa';
var _started = false;
// Expose public endpoint, needs to be available right from the start
if (!window.conversionalLauncher) {
    window.conversionalLauncher = {
        onReady: function () { return new Promise(function (resolve, reject) {
            waitForClient(function (data) {
                window.conversionalLauncher.isReady = true;
                resolve(data);
            }, reject);
        }); }
    };
}
var _reloadInFlight = null;
window.conversionalLauncher = __assign(__assign({}, window.conversionalLauncher), { destroy: function () {
        removeFromDOM();
        removeIframesFromDOM();
        resetIframeCreation();
        _started = false;
    }, reload: function () {
        // If double initialization was a problem, this is the line
        // if (_reloadInFlight) return _reloadInFlight
        _reloadInFlight = Promise.resolve()
            .then(function () {
            removeFromDOM();
            removeIframesFromDOM();
            resetIframeCreation();
            _started = false;
            return bootstrap();
        })
            .finally(function () {
            _reloadInFlight = null;
        });
        return _reloadInFlight;
    }, inlineWidgetCheckerInterval: function () {
        if (window.conversionalLauncher.inlineCheckerInterval)
            return;
        window.conversionalLauncher.inlineCheckerInterval = setInterval(function () {
            if (!window.conversionalLauncher.inlineWidgetIds)
                return;
            window.conversionalLauncher.inlineWidgetIds.forEach(function (id) {
                var container = document.getElementById(id);
                if (!container)
                    return;
                if (container.getAttribute('data-conversional-initialized'))
                    return;
                window.conversionalLauncher.inlineCheckerInterval = null;
                clearInterval(window.conversionalLauncher.inlineCheckerInterval);
                window.conversionalLauncher.reload();
            });
        }, 1000);
    } });
var bootstrap = function () {
    return new Promise(function (resolve, reject) {
        var urlParams = parseQueryString();
        if (_started) {
            reject();
            return;
        }
        _started = true;
        runLauncher(function (settings) {
            if (getRootLauncher()) {
                reject();
                return;
            }
            var isLazyMode = function () { return getJourneySettings().bootstrap === 'lazy'; };
            window.conversionalLauncher.journeySettings = settings;
            window.conversionalLauncher.lazy = isLazyMode();
            // Recognizing flash mode before fetching journey config
            if (!isLazyMode()) {
                // Just an iframe to fetch the main React bundle so it gets cached for the next loads
                addPreloaderIframe();
            }
            getJourneyConfig(settings).then(function (journeyConfig) {
                var _a;
                // Deep merging passed and fetched values to make blackList and whiteList parameters overwritable
                var configuration = {
                    configuration: deepMerge(journeyConfig.configuration, (window.conversionalWidget && window.conversionalWidget.config) || {})
                }.configuration;
                if (!configureUrl(configuration)) {
                    reject();
                    return false;
                }
                addLauncherStyles();
                initializeLauncher(settings, journeyConfig);
                callToActionUtils.onCTAClick(processCTAClick);
                callToActionUtils.createStyleTagForCTAs();
                if (urlParams.dynamic || urlParams.openWidget) {
                    renderLoading(true);
                }
                checkInlineWidgetAndRenderLoading(configuration);
                persistCurrentJourneyOnSettings((_a = journeyConfig === null || journeyConfig === void 0 ? void 0 : journeyConfig.configuration) === null || _a === void 0 ? void 0 : _a.id);
                renderLoading(configuration.loading);
                startMainWidget(configuration).then(resolve);
            });
        });
    });
};
/**
 * If clients are concernec by the Google Pagespeed Ranking the actual loading of the tool can be delayed until the first user interaction
 * This is an opt-in feature because it may diminish user experience, especially on mobile devices and inline rendering where no user interaction may take place.
 */
function startMainWidget(configuration) {
    return new Promise(function (resolve, reject) {
        if (!configuration.delayForPageSpeed) {
            return createIframes().then(resolve);
        }
        return waitForUserInteraction(function () { return createIframes().then(resolve); });
    });
}
/**
 * Processes a CTA click by either executing it directly or persisting the click information to be processed once the client is ready.
 */
export default function () {
    return new Promise(function (resolve, reject) {
        captureConversionalSettingsChange();
        if (document.body) {
            return bootstrap().then(resolve);
        }
        window.addEventListener('DOMContentLoaded', function () {
            bootstrap().then(resolve);
        });
    });
}
